import { render } from "./GroupGeneralComponent.vue?vue&type=template&id=4e1c0f46"
import script from "./GroupGeneralComponent.vue?vue&type=script&lang=js"
export * from "./GroupGeneralComponent.vue?vue&type=script&lang=js"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__